interface INavbarItems {
  id: number;
  name: string;
  path: string;
}

export const NAVBAR_ITEMS: INavbarItems[] = [
  {
    id: 0,
    name: "home",
    path: "/",
  },
  {
    id: 1,
    name: "cards",
    path: "/cards",
  },
  {
    id: 2,
    name: "packages",
    path: "/packages",
  },
  {
    id: 3,
    name: "sign-up",
    path: "/place-order",
  },
  {
    id: 4,
    name: "login",
    path: "/login",
  }
];
